import { Help } from '@atlaskit/navigation-system';
import { useIntl } from 'react-intl-next';
import { useRouter } from 'react-resource-router';

import { boysenberryPath } from '../../../routes/paths';

import { useHelpStore } from './help-provider';
import messages from './messages';

export const HelpButton = () => {
	const { isOpen, toggle } = useHelpStore();
	const [routeState] = useRouter();
	const { formatMessage } = useIntl();
	const isOnBoysenberryRoute = routeState.route?.path.startsWith(boysenberryPath);

	// In-product help is currently only available on the Boysenberry route
	return (
		isOnBoysenberryRoute && (
			<Help
				onClick={toggle}
				label={formatMessage(messages.helpButtonLabel)}
				isSelected={isOpen}
				testId="in-product-help-button"
			/>
		)
	);
};
